import { UpdateAttachment } from "../Requests/mutators";
import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import URLconfig from "../Util/URLConfig";
import axios from "axios";
import { getToken } from "../Util/Authenticate";
import { useLocation } from "react-router-dom";
import "./Applicant.css";
const AttachmentDetails = () => {
  const [isLoading, setisLoading] = React.useState(true);
  const location = useLocation();
  if (location.state) {
    let saveattachmentID = JSON.stringify(location.state.attachmentId);
    localStorage.setItem("attachmentId", saveattachmentID);
  }
  let attachmentId = JSON.parse(localStorage.getItem("attachmentId"));
  // const [attachment, setAttachment] = React.useState([]);
  const [tabs, settabs] = React.useState([]);
  const [addAttachment, setAddAttachment] = useState({
    attachmentId: attachmentId,
    attachmentName: "",
    attachmentTabId: 0,
    attachment: null,
  });
  const GetFiles = () => {
    var data = "";
    var config = {
      method: "post",
      url: `${URLconfig.API_BASE_URL}api/Admin/GetAttachmentbyID?attachmentID=${attachmentId}`,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        //console.log("Files API", JSON.stringify(response.data));
        setAddAttachment(response.data);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };
  const GetTabs = () => {
    var data = "";
    var config = {
      method: "post",
      url: `${URLconfig.API_BASE_URL}api/Admin/GetallAvaliableTabs`,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        //console.log("Files API", JSON.stringify(response.data));
        settabs(response.data);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };
  const onSubmit = async () => {
    try {
      setisLoading(true);
      await UpdateAttachment(addAttachment);
      setisLoading(false);
      alert("Update Occured Successfully");
      // window.location.href = "/#/dashboard";
      // window.location.href = `${URLconfig.BASE_URL}Policies/#/dashboard`;
      //window.location.href = `http://localhost:3000/#/dashboard`;
    } catch (err) {
      setisLoading(false);
      alert("Error while Updating, Please Try Again");
    }
  };
  useEffect(() => {
    setisLoading(false);
    GetFiles();
    GetTabs();
  }, []);

  return (
    <div>
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-lg-8 col-xl-6">
          <div class="card rounded-3">
            <div class="card-body p-4 p-md-5">
              <h3 class="mb-4 pb-2 pb-md-0 mb-md-5 px-md-2 ButtonFrame">
                Attachment Details Panel
              </h3>
              <form class="px-md-2">
                <div class="form-outline w-100 mb-4">
                  <TextField
                    type="text"
                    id="form3Example1q"
                    className="w-100"
                    value={addAttachment.attachmentName}
                    onChange={(e) => {
                      setAddAttachment({
                        ...addAttachment,
                        attachmentName: e.target.value,
                      });
                    }}
                    required
                    name="attachmentName"
                    label="Policy Title"
                  />
                </div>
                <div class="form-outline mb-4">
                  <select
                    class="form-select"
                    value={addAttachment.attachmentTabId}
                    onChange={(e) => {
                      setAddAttachment({
                        ...addAttachment,
                        attachmentTabId: e.target.value,
                      });
                    }}
                    name="courseId"
                  >
                    <option selected>Add Policy Department</option>
                    {tabs.map((data, i) => (
                      <option value={data.tabId}>{data.tabName}</option>
                    ))}
                  </select>
                </div>
                <div class="form-outline w-100 mb-4">
                  <input
                    type="file"
                    id="form3Example2q"
                    className="w-100"
                    value={
                      addAttachment.attachment && addAttachment.attachment.files
                    }
                    onChange={(e) => {
                      setAddAttachment({
                        ...addAttachment,
                        attachment: e.target.files[0],
                      });
                    }}
                    accept=".pdf"
                    name="attachment"
                  />
                </div>
                <button
                  type="reset"
                  class="btn btn-success col-3"
                  onClick={() => onSubmit()}
                  disabled={isLoading}
                >
                  {isLoading == true ? "Updating Attachment..." : "Update"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttachmentDetails;
